/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetReportDefinitionByReportTypeQueryResponse, GetReportDefinitionByReportTypePathParams, GetReportDefinitionByReportTypeQueryParams, GetReportDefinitionByReportType400, GetReportDefinitionByReportType404 } from "../models/GetReportDefinitionByReportType";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getReportDefinitionByReportType } from "../axios/getReportDefinitionByReportType";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getReportDefinitionByReportTypeQueryKey = (reportType: GetReportDefinitionByReportTypePathParams["reportType"], params: GetReportDefinitionByReportTypeQueryParams = {}) => ["audit-reports-api", { url: '/report-definitions/default/:reportType', params: {reportType:reportType} }, ...(params ? [params] : [])] as const

export type GetReportDefinitionByReportTypeQueryKey = ReturnType<typeof getReportDefinitionByReportTypeQueryKey>

export function getReportDefinitionByReportTypeQueryOptions(reportType: GetReportDefinitionByReportTypePathParams["reportType"], params?: GetReportDefinitionByReportTypeQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getReportDefinitionByReportTypeQueryKey(reportType, params)
        return queryOptions<GetReportDefinitionByReportTypeQueryResponse, ResponseErrorConfig<GetReportDefinitionByReportType400 | GetReportDefinitionByReportType404>, GetReportDefinitionByReportTypeQueryResponse, typeof queryKey>({
         enabled: !!(reportType),
         queryKey,
         queryFn: async ({ signal }) => {
            return getReportDefinitionByReportType(reportType, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves the default report definition for the specified report type. For the specified blueprint version (or latest if not provided), returns the default definition. If definitionId is provided, returns that specific definition instead. If no default definition exists, creates and saves a default one from the blueprint.
 * @summary Get default report definition
 * {@link /report-definitions/default/:reportType}
 */
export function useGetReportDefinitionByReportType<TData = GetReportDefinitionByReportTypeQueryResponse, TQueryData = GetReportDefinitionByReportTypeQueryResponse, TQueryKey extends QueryKey = GetReportDefinitionByReportTypeQueryKey>(reportType: GetReportDefinitionByReportTypePathParams["reportType"], params?: GetReportDefinitionByReportTypeQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetReportDefinitionByReportTypeQueryResponse, ResponseErrorConfig<GetReportDefinitionByReportType400 | GetReportDefinitionByReportType404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getReportDefinitionByReportTypeQueryKey(reportType, params)
         

         const query = useQuery({
          ...getReportDefinitionByReportTypeQueryOptions(reportType, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetReportDefinitionByReportType400 | GetReportDefinitionByReportType404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}